export const ALERT_DIALOG_TEXT = {
  cancel: '취소',
  confirm: {
    default: '확인',
    danger: '삭제',
  },
} as const;
